import React, { forwardRef } from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './Typography.module.scss';

const cx = classnames.bind(styles);

const tags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body: 'p',
  'body-s': 'p',
  'body-xs': 'p',
};

const Typography = forwardRef(
  ({ type = 'body', bold, italic, isAlert, onClick = null, className, children, ...props }, ref) => {
    const Tag = tags[type];

    return (
      <Tag
        ref={ref}
        className={cx('text', className, `text--${type}`, {
          'text--bold': bold,
          'text--italic': italic,
          'text--clickable': !!onClick,
          'text--alert': isAlert,
        })}
        onClick={onClick}
        {...props}
      >
        {children}
      </Tag>
    );
  },
);

Typography.propTypes = {
  type: T.oneOf(Object.keys(tags)),
  bold: T.bool,
  italic: T.bool,
  isAlert: T.bool,
  onClick: T.func,
  className: T.oneOfType([T.func, T.string]),
  children: T.oneOfType([T.string, T.number, T.node]),
};

// ({ type = 'body', bold, italic, isAlert, onClick = null, className, children, ...props }, ref) => {

export default Typography;
